import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Servicios from './pages/Servicios';
import Equipo from './pages/Equipo';
import Contacto from './pages/Contacto';
import Privacidad from './pages/Privacidad';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/"           element={<Home />} />
            <Route path="/servicios"  element={<Servicios />} />
            <Route path="/equipo"     element={<Equipo />} />
            <Route path="/contacto"   element={<Contacto />} />
            <Route path="/privacidad" element={<Privacidad />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;